export enum LocaleStorageKeys {
  language = 'language',
  sessionData = 'sessionData',
  rsOrderSuccessShowContentKey = 'rsOrderSuccessShowContent',
  cameFrom = 'cameFrom',
}
